module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex/assessment_achievements/2@2x_25bfe3153223a2c6e9a44dbb0440ff8f.png";